const getQueryParamsFromObject = queryParamObject => {
  const searchParams = new URLSearchParams();
  Object.entries(queryParamObject).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(arrayValue => {
        searchParams.append(key, arrayValue.toString());
      });
    } else if (value !== null && value !== undefined) {
      searchParams.append(key, value.toString());
    }
  });
  return `${Object.keys(queryParamObject).length ? '?' : ''}${searchParams.toString()}`;
};
export default getQueryParamsFromObject;